import { csx } from '@vtex/admin-ui'

export const styles = {
  background: (isFinished: boolean) =>
    csx({
      width: '100%',
      background: isFinished ? '$gray40' : '$secondary',
      height: '0.5rem',
      borderRadius: 2,
    }),
  bar: (disabled: boolean) =>
    csx({
      background: disabled ? '$gray40' : '$black',
      height: '0.5rem',
      borderRadius: 2,
    }),
}
